import React from 'react'
import { Box } from './styled'

export const Bullet = props => {
    return <Box color={props.color} size={props.size} />
}
